<template>
  <div>
    <page-heading :title="$t(`${translationPrefix}.title`)"></page-heading>

    <content-placeholder v-if="fetching">
      <el-card>
        <p class="text text-10 text-h-20"></p>
        <p class="text text-50"></p>
        <p class="text text-25"></p>
        <p class="text text-25"></p>
      </el-card>
    </content-placeholder>

    <el-card v-else :key="appId" :app="app" v-for="(app, appId) in apps">
      <div slot="header">
        {{ app.name }}
      </div>
      <div slot="actions">
        <el-tooltip class="item" effect="dark" content="Cancel Subscription" placement="top">
          <el-button size="small" plain @click="handleCancelSubscription(app.id)" v-if="subscribed(app.id)"><i class="fas fa-ban"></i></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="Change Subscription" placement="top">
          <el-button size="small" @click="handleToggleSwitchMode()" v-if="subscribed(app.id)"><i class="fas fa-box-open"></i></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="App Settings" placement="top">
          <router-link :to="{ name: 'appSettings', params: { id: app.id } }">
            <el-button plain size="small" v-if="subscribed(app.id)"><i class="fas fa-cog"></i></el-button>
          </router-link>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="Invite Users" placement="top">
          <router-link :to="{ name: 'inviteUsers', params: { id: app.id } }">
            <el-button plain size="small" v-if="subscribed(app.id)"><i class="fas fa-user-plus"></i></el-button>
          </router-link>
        </el-tooltip>
      </div>
      <div v-if="!subscribed(app.id) || switchMode">
        <el-row :gutter="20" type="flex" justify="space-around">
          <el-col v-for="(appPackage, index) in app.packages" :key="index">
            <el-card :class="appPackage.name.toLowerCase()">
              <div slot="header">
                {{ appPackage.name }}
              </div>
              <div class="text item" center>
                Number of Users: <b>{{ appPackage.max_users }}</b><br><br>
                <el-alert
                  title="Currently subscribed!"
                  v-if="packageSubscribed(appPackage.id)"
                  type="success"
                  center
                  :closable="false">
                </el-alert>
                <el-button v-else @click="handleSubscribe(app.id, appPackage.uuid)">Select This</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div v-if="switchMode">
          <el-button @click="handleToggleSwitchMode()">Cancel</el-button>
        </div>
      </div>
      <div v-else>
        <el-alert
          title="This app is included in your package!" v-if="subscribed(app.id)"
          type="success"
          center
          :closable="false">
        </el-alert>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'AppsSettingsPage',
    data() {
      return {
        switchMode: false,
        translationPrefix: 'pages.appsSettings',
      };
    },
    created() {
      this.fetchApps();
    },
    computed: {
      ...mapGetters('entities/appMemberships', ['query']),
      ...mapGetters('entities/apps', ['fetching', 'isUpdating']),

      apps() {
        return this.$store.getters['entities/apps/query']()
          .with('packages')
          .get();
      },
    },
    methods: {
      ...mapActions('entities/apps', ['fetchApps']),
      ...mapActions('entities/appMemberships', ['cancelSubscription']),

      subscribed(appId) {
        return this.query()
          .where('app_id', appId)
          .where('active', true)
          .first();
      },
      packageSubscribed(packageId) {
        return this.$store.getters['entities/appMemberships/query']()
          .where('package_id', packageId)
          .where('active', true)
          .first();
      },
      subscribe(appId, packageId) {
        this.$store.dispatch('entities/appMemberships/subscribe', { appId, packageId })
          .then(() => {
            this.handleToggleSwitchMode();
          });
      },
      handleSubscribe(appId, packageId) {
        this.$confirm('Do you really want to subscribe to this package?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.subscribe(appId, packageId);
        });
      },
      handleCancelSubscription(appId) {
        this.$confirm('Are you sure you want to cancel your subscription?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.cancelSubscription(appId)
            .then(() => {
              this.switchMode = false;
            });
        });
      },
      handleToggleSwitchMode() {
        this.switchMode = !this.switchMode;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .app-card {
    margin-bottom: 15px;
    .card-header {
      button {
        margin-right: 0px !important;
        margin-left: 10px !important;
        float: right;
      }
    }
  }
  //   ul {
  //     li {
  //       padding: 10px 0;
  //     }
  //   }
  //   .el-row {
  //     .el-col {
  //       padding: 20px 40px 10px 40px;
  //       text-align: center;
  //       border: 1px solid #eaeaea;
  //       color: #666;

  //       .icon {
  //         font-size: 60px;
  //         color: #999;
  //       }
  //       .action-description {
  //         padding: 20px;
  //       }
  //     }
  //   }
  // }
</style>



// WEBPACK FOOTER //
// src/pages/AppsSettings.vue